import HeaderPortal from "components/portal/header-portal";
import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import { StatusCell } from "@/components/status/cell";
import ProjectNameCell from "@/modules/work/projects/cells/name";

export default function Skills() {

    const columns = [
        {
            id: "name",
            header: "Name",
            accessorKey: "name",
            cell: ProjectNameCell,
            sortable: true,
        },
    ];

    const fields = ["id", "name", "logo"];


    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="skills"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Skills</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Skills"
                    endPoint="skills"
                    columns={columns}
                    meta={{
                        fields,
                    }}
                    sortBy="name"
                    sortOrder="aesc"
                    href={(item) => item.id}
                    rowClassName="h-13"
                />
            </div>
        </div>
    );
}
